// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from  './store'
import './filter'// 加载过滤器

// 移动端H5适配样式
import './assets/mobile.css'

// 设置反向代理，前端请求通过 webpack proxy 转发到后端
var axios = require('axios')
axios.defaults.baseURL = '/api'
// 全局注册，之后可在其他组件中通过 this.$axios 发送数据
Vue.prototype.$axios = axios
Vue.config.productionTip = false
axios.defaults.withCredentials = true

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import QRCode from 'qrcodejs2'
Vue.use(VueQuillEditor)

// 钉钉工具函数全局注册
import { isInDingTalk } from './utils/dingtalk'
Vue.prototype.$isInDingTalk = isInDingTalk


router.beforeEach((to, from, next) => {
    // 已登录状态下加载admin菜单
    if (store.state.user && store.state.user.userName && to.path.startsWith('/admin')) {
      initAdminMenu(router, store)
    }
    // 已登录状态下访问 login 页面或根路径直接跳转到投票规则页
    if (store.state.user && store.state.user.userName && (to.path === '/login' || to.path === '/')) {
      next({
        path: '/vote-rules'
      })
      return
    }
    // 需要登录权限的页面
    if (to.meta.requireAuth) {
      if (store.state.user && store.state.user.userName) {
        axios.get('/authentication').then(resp => {
          if (resp) next()
        }).catch(() => {
          next({
            path: '/login',
            query: {redirect: to.fullPath}
          })
        })
      } else {
        next({
          path: '/login',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      next()
    }
  }
)

const initAdminMenu = (router, store) => {
  if (store.state.adminMenus.length > 0) {
    return;
  }
  axios.get('/menu').then(resp => {
    if (resp && resp.status === 200) {
      var fmtRoutes = formatRoutes(resp.data.result)
      router.addRoutes(fmtRoutes)
      store.commit('initAdminMenu', fmtRoutes)
    }
  })
}

const formatRoutes = (routes) => {
  let fmtRoutes = []
  routes.forEach(route => {
    if (route.children) {
      route.children = formatRoutes(route.children)
    }

    let fmtRoute = {
      path: route.path,
      component: resolve => {
        require(['./components/admin/' + route.component + '.vue'], resolve)
      },
      name: route.name,
      nameZh: route.nameZh,
      iconCls: route.iconCls,
      meta: {
        requireAuth: true
      },
      children: route.children
    }
    fmtRoutes.push(fmtRoute)
  })
  return fmtRoutes
}

Vue.prototype.setDialogWidth = function () {
    let val = document.body.clientWidth
    const def = 800 // 默认宽度
    if (val < def) {
      this.dialogWidth = '100%'
    } else {
      this.dialogWidth = '30%'
    }
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js